import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RoutableTeamText = ({
  team
}) => /*#__PURE__*/_jsxs("span", {
  children: [team.name, /*#__PURE__*/_jsx(Text, {
    as: "span",
    color: "icon-core-subtle",
    children: ` (${team.numRoutableUsersInHierarchy})`
  })]
});
RoutableTeamText.displayName = 'RoutableTeamText';
export default RoutableTeamText;